import { referralTypes } from '../types/refferalTypes';

// 

const initialState = {
  myRefDetails: {
    claimedBonus: 0,
    pendingBonus: 0,
    referralCode:''
  },

}

export const getReferralDetailsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case referralTypes.GET_MY_REFERRALS_DETAILS_REQUEST_SUCCESS:
      return {
        ...state,
        myRefDetails:action.payload
      }
    
    default: return state
   }

}